// Import dependencies
import "@babel/polyfill";
import './modules/polyfills';
import picturefill from 'picturefill';
import 'nodelist-foreach-polyfill';
import objectFitImages from 'object-fit-images';

// Import first-party functionality modules
import adStack from './modules/ad-stack';
import arnAnalytics from './modules/analytics';
import videoPlayerManager from './modules/video-player-manager';
import pjaxHandler from './modules/pjax';
import ArnDragSlider from './modules/drag-slider';
import AdblockDetectorHandler from './modules/adblock-detector';

// Import component modules
import GlobalHeader from './../../parts/02_organisms/navbar/Global_Header';
import OffCanvasNav from './../../parts/02_organisms/navbar_off_canvas/Navbar_Off_Canvas';
import videos from './../../parts/02_organisms/videos';
import audioPlayer from './../../parts/02_organisms/audio_player';
import Schedule from './../../parts/02_organisms/schedule';
import PhotoGallery from './../../parts/02_organisms/photo_gallery';
import NavSearch from './../../parts/02_organisms/navbar/nav_top_search';
import StrapIheart from './../../parts/01_molecules/strap_iheart';
import staticAudioPlayer from './../../parts/02_organisms/audio_player_static';

if (typeof siteData !== 'undefined') {
  window.siteData = siteData;
}

// Init dependencies
picturefill();

// Init first party and component modules
AdblockDetectorHandler();
adStack();
arnAnalytics();
videoPlayerManager();
pjaxHandler();
videos();
audioPlayer();
staticAudioPlayer();
NavSearch();

// Store components in browser
window.ARN = {
  Components: {
    GlobalHeader,
    OffCanvasNav,
    Schedules: [],
    Galleries: [],
    Sliders: [],
  },
};

// Function which can be called on pageview so initialise all required components
window.arnPageViewInit = function() {
  window.ArnAnalytics.pageviewEvent();
  StrapIheart();
  window.ARN.Components.Galleries.forEach( element => {
    element.destroy();
  });
  window.ARN.Components.Schedules = [];
  window.ARN.Components.Galleries = [];
  window.ARN.Components.Sliders.forEach(slider => {
    slider.destroySlideHooks();
  });
  window.ARN.Components.Sliders = [];

  Schedule();
  PhotoGallery();

  if (typeof window.instgrm !== 'undefined') {
    window.instgrm.Embeds.process();
  }

  if (typeof window.twttr !== 'undefined') {
    window.twttr.widgets.load();
  }

  const sliders = document.querySelectorAll('.js-slider');
  sliders.forEach(slider => {
    console.log(slider);
    window.ARN.Components.Sliders.push(ArnDragSlider(slider));
  });

  if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) {
    objectFitImages();
    setTimeout(function() {
      window.resizeTo(window.outerWidth - 1, window.outerHeight - 1);
      window.resizeTo(window.outerWidth + 1, window.outerHeight + 1);
    }, 250);
  }
};

window.addEventListener("hashchange", function () {
  window.scrollTo(window.scrollX, window.scrollY - 150);
});

window.arnPageViewInit();
